var t = new Date()
var currentDay = t.getDate();
var currentMonth = t.getMonth();
var currentyear = t.getFullYear();
var weekDay = t.getDay();
var currentHour = t.getHours()

var specialProduct = false;
var specialProduct2 = false;
var specialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  // if (itemCollections.toLowerCase().indexOf('november 22'.toLowerCase()) > -1) {
  //   specialProduct2 = true;
  // } 

  if (itemTitle.toLowerCase().indexOf('Bagels'.toLowerCase()) > -1) {
    specialProduct = true;
  } 
}


var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  var selectedDayNumber = selectedDate.getDate();
  if (selectedDayNumber === currentDay && currentMonth === selectedMonth) { 
    timepicker.set('disable',[{ from: [8, 0], to: [23, 0] }]); 
  }
console.log(selectedDayNumber)
//   if(selectedDate.getDate() === 17 && selectedMonth === 8) {
//   	timepicker.set('disable',[{ from: [11, 00], to: [11, 00] }]); 
//   }
	
}

////
var overridingRules = [];

for (let item of crItems) {
    const crItemId = item.id;
    for (let rule of CRoverRidingRules) {
        for (let product of rule.products) {
            for (let variant of product.variants) {
                const variantId = Number(variant.plainVariantId);
                if (variantId == crItemId) {
                    overridingRules.push(rule.name)
                }
            }
        }
    }
}
// If the overridingRules contains the same element we don't need to display the mssage,
// otherwise it means that products from multiple rules are in the cart
const allEqual = arr => arr.every( v => v === arr[0] )
console.log(overridingRules, allEqual(overridingRules))
var displayMessage = false;
if (overridingRules.length > 1 && !allEqual(overridingRules) ) {
    displayMessage = true;
}
document.addEventListener('crJQActivated', function (e) {
  if (displayMessage === true) {
    console.log('display')
      setTimeout(function(){        
        jqCR('.cr-block-message').text("Dear customer, please note that certain products are only baked on specific days. Your basket contains one or more items not available on your pick up date. Please consult the bread schedule and edit accordingly")
        disableCheckoutButton();
        var tt = setInterval(function(){disableCheckoutButton();}, 1000);
        setTimeout(function() { clearInterval(tt); }, 10000);  

      }, 100)
  }  
})

function activateCheckoutButton(){
    document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton(){    
    document.querySelector('[name=checkout]').disabled = true;
}


// var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
//   console.log({blackoutdatesCollection})
// //   if (specialProduct === true) {
// //   	picker.set('disable', [true, { from: [2020, 8, 10], to: [2020, 8, 23] }, { from: [2020, 9, 13], to: [2022, 9, 7] }]);
// //     picker.set('max', 100);   
// //   }	else {
// //     
// //   }  
//   picker.set('disable', blackoutdatesCollection);
// }